/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { GuidedExpressionRenderer } from "abreact/expression/ui/readonly/GuidedExpressionRenderer";
import { AbField } from "abreact/form/AbField";
import * as AbFormHooks from "abreact/form/AbFormHooks";
import React from "react";
export function AbGuidedExpressionField(props) {
  const viewModel = AbFormHooks.useDataValueFieldViewModel("ab-guided-expression-field", props);
  const expressionString = props.currentValue !== undefined ? props.currentValue : props.subject ? props.accessor.getClientValue(props.subject) : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, viewModel && /*#__PURE__*/React.createElement(AbField, viewModel.fieldProps, /*#__PURE__*/React.createElement(GuidedExpressionRenderer, {
    expression: expressionString
  })));
}
//# sourceMappingURL=AbGuidedExpressionField.js.map
